export default "__VITE_PUBLIC_ASSET__09583a55__"